import * as React from 'react'

import { Box, Section, Text, Title, TogglerCheckbox } from '@factorialco/deprecated-design-system'
import type { Form as FactorialForm } from 'factorial-form'

import { observer } from 'mobx-react'

import asyncAction from 'modules/core/lib/asyncAction'
import helpCenterUrl from 'modules/core/lib/helpCenterUrl'
import i18n from 'modules/core/lib/i18n'
import { EventTypes, dispatch } from 'modules/core/lib/pubSub'
import app from 'modules/core/store/models/app'

import type AttendanceSetting from 'modules/attendance/store/models/AttendanceSetting'

type TitleProps = React.ComponentProps<typeof Title>

interface Props {
  attendanceSetting: AttendanceSetting
  settingForm: FactorialForm
}

const PolicyShiftLocation = ({ attendanceSetting, settingForm }: Props) => {
  const clockInLocationEnableField = settingForm.get('enable_clock_in_location')
  const clockInLocationEnable = clockInLocationEnableField.value
  const handleToggleClockInLocationEnable = (newValue: boolean) => {
    clockInLocationEnableField.set(newValue)
    updatePolicy()
  }

  const updatePolicy = async () => {
    const { success } = await asyncAction(
      async () => {
        await settingForm.save(attendanceSetting)
        dispatch({
          type: EventTypes.TIMETRACKING_POLICY_UPDATED,
        })

        return settingForm
      },
      {
        successFlash: true,
      }
    )

    if (success) {
      app.setFlash({
        type: 'correct',
        message: i18n.t('time_tracking.settings.updated_message'),
      })
    }
  }
  const descriptionLink: TitleProps['link'] = {
    href: helpCenterUrl('time_tracking'),
    label: i18n.t('time_tracking.settings.shift_location.learn_more'),
  }

  return (
    <Section
      illustration="location-building-pin"
      title={i18n.t('time_tracking.settings.tabs.shift_location')}
      link={descriptionLink}
      description={i18n.t('time_tracking.settings.shift_location.description')}
    >
      <Box>
        <Box
          border={{
            all: {
              width: 's1',
              style: 'solid',
              color: 'grey400',
            },
          }}
          borderRadius={{
            all: 'abs008',
          }}
          padding="s16"
        >
          <Box flexDirection="row" justifyContent="spaceBetween">
            <Box gap="s8">
              <Text.Normal weight="medium">
                {i18n.t('time_tracking.settings.shift_location.toggle.label')}
              </Text.Normal>
              <Text.Normal color="grey800" htmlTag="div">
                {i18n.t('time_tracking.settings.shift_location.toggle.hint')}
              </Text.Normal>
            </Box>
            <Box>
              <TogglerCheckbox
                labelBefore
                value={clockInLocationEnable}
                onChange={(newValue) => handleToggleClockInLocationEnable(newValue)}
              />
            </Box>
          </Box>
        </Box>
      </Box>
    </Section>
  )
}

export default observer(PolicyShiftLocation)
